import { enableMapSet, produce } from "immer"

enableMapSet()

export function parseState(obj: any): any {
  return produce(obj, (draft: any) => {
    const traverse = (value: any): any => {
      if (typeof value === "string" && value.startsWith("__bigint__")) {
        return BigInt(value.slice(10))
      }

      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          value[index] = traverse(item)
        })
      } else if (typeof value === "object" && value !== null) {
        Object.keys(value).forEach((key) => {
          value[key] = traverse(value[key])
        })
      }

      return value
    }

    traverse(draft)
  })
}
